import React, { Suspense } from 'react'
import { DynamicPortal } from '~/components/utils'
import { RelatedProducts } from '~/pages/Products'
import { ProductPage as Page } from './ProductPage'

/* TODO: Use this when more metafields++ are available from window.PRODUCT
export const ProductPage: React.FC = () => {
	const fallbackProduct: Product = toGqlProduct(window.PRODUCT as ProductJson)

	return (
		<Suspense fallback={<ProductPageComponent product={fallbackProduct} />}>
			<Page />
		</Suspense>
	)
}
*/
export const ProductPage: React.FC = () => (
	<Suspense fallback={null}>
		<Page />
		<DynamicPortal selector="#related_products">
			<RelatedProducts />
		</DynamicPortal>
	</Suspense>
)
